import { CommonModule } from '@angular/common';
import {Component, Input} from '@angular/core';

@Component({
    selector: 'logo-widget',
    standalone: true,
    imports: [CommonModule],
    template: ` <svg
    [ngClass]="[className, reverseTheme ? 'fill-surface-0 dark:fill-surface-900' : 'fill-surface-900 dark:fill-surface-0']"
    width="152"
    height="32"
    viewBox="0 0 152 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_697_2374)">
      <path d="M9.49284 22.2426L15.4179 6.9315V0L5.17065 23.3063L9.49284 22.2426Z" />
      <path
        d="M15.9999 8.65381L10.6243 22.5453L15.9999 26.7894L21.3756 22.5453L15.9999 8.65381ZM13.8527 18.8512L15.0306 18.004C15.656 17.5538 16.3358 18.4996 15.7105 18.9492L14.5327 19.7964C13.9144 20.2415 13.2245 19.303 13.8527 18.8512ZM18.4382 20.7471L14.9075 23.2866C14.2895 23.7315 13.599 22.7935 14.2276 22.3414L17.7582 19.8019C18.3839 19.3517 19.0631 20.2975 18.4382 20.7471Z"
      />
      <path d="M15.4175 27.8132L9.78876 23.3691L5.47021 24.4319L15.4175 32.0003V27.8132Z" />
      <path d="M22.2109 23.3691L16.582 27.8132V32.0003L26.5294 24.4319L22.2109 23.3691Z" />
      <path d="M16.582 6.9315L22.5071 22.2426L26.8293 23.3062L16.582 0V6.9315Z" />
    </g>
    <path
      d="M47.584 6.96C53.008 6.96 56.056 10.032 56.056 15.504C56.056 20.952 53.08 24 47.728 24H41.92V6.96H47.584ZM45.04 21.288H47.584C51.136 21.288 52.864 19.392 52.864 15.504C52.864 11.568 51.136 9.672 47.584 9.672H45.04V21.288ZM58.0103 6.96H61.1303V24H58.0103V6.96ZM63.1233 24L69.2673 6.96H73.0833L79.2273 24H75.9633L74.5473 19.968H67.8033L66.3873 24H63.1233ZM68.7153 17.304H73.6353L71.1873 10.104L68.7153 17.304ZM80.8394 6.96H85.0394L89.7434 20.16L94.4234 6.96H98.6474V24H95.5274V12.288L91.2314 23.976H88.2554L83.9594 12.288V24H80.8394V6.96ZM109.264 24.384C104.2 24.384 101.128 21 101.128 15.504C101.128 9.96 104.2 6.576 109.264 6.576C114.352 6.576 117.376 9.96 117.376 15.504C117.376 21 114.352 24.384 109.264 24.384ZM104.392 15.504C104.392 19.344 106.192 21.672 109.264 21.672C112.336 21.672 114.16 19.344 114.16 15.504C114.16 11.616 112.336 9.288 109.264 9.288C106.192 9.288 104.392 11.616 104.392 15.504ZM119.559 6.96H123.207L130.455 19.608V6.96H133.599V24H129.831L122.679 11.688V24H119.559V6.96ZM142.321 6.96C147.745 6.96 150.793 10.032 150.793 15.504C150.793 20.952 147.817 24 142.465 24H136.657V6.96H142.321ZM139.777 21.288H142.321C145.873 21.288 147.601 19.392 147.601 15.504C147.601 11.568 145.873 9.672 142.321 9.672H139.777V21.288Z"
    />
    <defs>
      <clipPath id="clip0_697_2374">
        <rect width="32" height="32" />
      </clipPath>
    </defs>
  </svg>`
})
export class LogoWidget {
    @Input() className: string = '';
    @Input() reverseTheme: boolean = false;
}
